<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle"><i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"></i>服务单详情</div>
    </div>
    <div style="width: 1056px;margin: 0 auto;" class="filtrate">
      <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd;">
        <div class="form-title">
          <div style="margin-left:10px;">
            <i class="fas fa-exclamation-circle"></i>
            退货商品
          </div>
        </div>
        <div class="table">
          <template>
            <el-table border :data="tableData" style="margin:0 auto">
              <el-table-column align="center" label="商品图片" width="100">
                <img :src="serve+'/' + img" alt width="70px" height="72px">
              </el-table-column>
              <el-table-column align="center" prop="title" label="商品名称" width="200"></el-table-column>
              <el-table-column prop="item_no" align="center" label="货号" width="150"></el-table-column>
              <el-table-column align="center" label="价格" width="150">
                <template slot-scope="scope">
                  <i style="font-style:normal">￥</i>
                  {{scope.row.selling_price}}
                </template>
              </el-table-column>
              <el-table-column prop="specification" align="center" label="属性" width="150"></el-table-column>
              <el-table-column prop="number" align="center" label="数量"></el-table-column>

              <el-table-column align="center" label="小计">
                <template slot-scope="scope">
                  <i style="font-style:normal">￥</i>
                  {{scope.row.selling_price*scope.row.number}}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd;margin-top:30px;">
      <div class="form-title">
        <div style="margin-left:30px;line-height:46px">服务单信息</div>
      </div>
      <div style="height:16px;wiidth:100%;background:#fff"></div>
      <div class="table">
        <table class="tab_box">
          <tr class="tab_tr">
            <th class="tab_th">服务单号</th>
            <td class="tab_td">{{code}}</td>
          </tr>

          <tr class="tab_tr">
            <th class="tab_th">申请状态</th>
            <td class="tab_td" style="color: #f64e62;">{{status}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">申请时间</th>
            <td class="tab_td">{{create_time}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">用户账号</th>
            <td class="tab_td">{{mobile}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">联系人</th>
            <td class="tab_td">{{link_name }}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">联系电话</th>
            <td class="tab_td">{{link_mobile}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">问题描述</th>
            <td class="tab_td">{{cause}}</td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th" style="height:80px">凭证照片</th>
            <td class="tab_td">
              <div
                style="float: left;margin-right:20px; width:104px;height:50px;    border:1px solid rgba(221, 221, 221, 1);"
                v-for="val in imgage"
                :key="val.value"
              > 
                <el-popover placement="bottom" width="500" trigger="hover">
                  <p>
                    <img width="500" height="300" :src="serve+'/'+val" alt>
                    
                  </p>
                  <img
                    slot="reference"
                    :src="serve+'/'+val"
                    width="104"
                    height="50"
                    alt
                  >
             
                </el-popover>
              </div>
            </td>
          </tr>
          <div style="height:30px"></div>
          <tr class="tab_tr">
            <th class="tab_th">退运费</th>
            <td class="tab_td">
              <template>
                <el-radio :disabled="show2" v-model="express_money" label="0">不退运费</el-radio>
                <el-radio :disabled="show2" v-model="express_money" label="1">退运费</el-radio>
              </template>
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">退款金额</th>
            <td class="tab_td">
              <i style="font-style:normal">￥</i>
              {{total_money}}
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">确认退款金额</th>
            <td class="tab_td">
              <el-input :disabled="show2" style="width:33%" v-model="refund"></el-input>
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">选择收货点</th>
            <td class="tab_td">
              <template>
                <el-select
                  :disabled="show2"
                  style="width:33%"
                  @change="site"
                  v-model="value110"
                  placeholder="选择收货点"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.address1"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </template>
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">收货人姓名</th>
            <td class="tab_td">
              <el-input :disabled="show2" style="width:33%" v-model="name"></el-input>
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">所在区域</th>
            <td class="tab_td">
              <el-col :span="4" style="margin-right:4px;">
                <el-select
                  :disabled="show2"
                  v-model="province_value"
                  placeholder="省"
                  @change="handeladr1"
                >
                  <el-option
                    v-for="item in province"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-col>

              <el-col :span="5" style="margin-right:4px;">
                <el-select
                  :disabled="show2"
                  v-model="city_value"
                  placeholder="市"
                  @change="handeladr2"
                >
                  <el-option
                    v-for="item in city"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-select :disabled="show2" v-model="area_value" placeholder="区">
                  <el-option
                    v-for="item in area"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-col>
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">详细地址</th>
            <td class="tab_td">
              <el-input :disabled="show2" style="width:33%" v-model="address"></el-input>
            </td>
          </tr>
          <tr class="tab_tr">
            <th class="tab_th">联系电话</th>
            <td class="tab_td">
              <el-input :disabled="show2" style="width:33%" v-model="mobel"></el-input>
            </td>
          </tr>
          <div style="height:30px"></div>
          <tr class="tab_tr">
            <th class="tab_th">处理备注</th>
            <td class="tab_td">
              <el-input :disabled="show2" style="width:33%" v-model="remark"></el-input>
            </td>
          </tr>
          <div style="height:50px"></div>
        </table>
        <div style="width:300px;height:150px;margin:0 auto;margin-top:30px;" v-show="show">
          <el-row>
            <el-button style="margin-left:50px;" type="success" @click="submit()">确认退货</el-button>
            <el-button type="danger" @click="reject()">拒绝退货</el-button>
          </el-row>
        </div>
        <div
          style="width:300px;height:150px;margin:0 auto;margin-top:30px;"
          id="submit"
          v-show="show1"
        >
          <el-row>
            <el-button style="margin-left:100px;" type="success" @click="submit1()">确认收货</el-button>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
   

<script>
import $ from "jquery";
export default {
  name: "gallery",
  data() {
    return { serve: this.$store.state.serve,
      show: true,
      show1: false,
      show2: false,
      options: [],
      value110: "",

      tableData: [],
      username: "",
      token: "",
      id: this.$route.params.id,
      img: "",

      orderCode: "",
      status: "",
      create_time: "",
      link_mobile: "", //shoujihao
      mobile: "", //用户账号
      link_name: "",
      cause: "", //原因
      return_type: "",
      imgage: [],
      total_money: "",
      express_money: "0",
      refund: "",
      name: "",
      address: "",
      mobel: "",
      remark: "",
      province: null,
      province_value: "",
      city: null,
      city_value: "",
      area: null,
      area_value: "",
      address1: "",
      address_id: "",
      code: ""
      /////////////////
    };
  },
  created() {
    this.$store.state.leftTitle = "退货申请处理";
    this.$store.state.topActiveId = 3;
    this.geting();
    this.consignee();
    this.select();
  },

  methods: {
    submit1() {
      //确定收货
      const _this = this;
      this.axios
        .get(this.serve+"/admin/receive_return_product", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.$router.push({ path: "/admin/d_returns" });
          }else if(res.data.code == '403'){
            _this.$message.error(res.data.msg); 
          } else {
            _this.open4();
          }
        });
    },
    reject() {
      //拒绝
      const _this = this;
      if (this.remark == "") {
        this.$message.error("请输入处理备注");
        return;
      }
      this.axios
        .get(this.serve+"/admin/refuse_return_product", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            remark: this.remark
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.$router.push({ path: "/admin/d_returns" });
          }else if(res.data.code == '403'){
            _this.$message.error(res.data.msg); 
          } else {
            _this.open4();
          }
        });
    },
    submit(id) {
      if (this.refund == "") {
        this.$message.error("请确定退款金额");
        return;
      }
      if (this.name == "") {
        this.$message.error("请输入姓名");
        return;
      }
      if (this.province_value == null) {
        this.$message.error("请输入所在区域");
        return;
      }
      if (this.city_value == null) {
        this.$message.error("请输入所在区域");
        return;
      }

      if (this.area_value == null) {
        this.$message.error("请输入所在区域");
        return;
      }
      if (this.address == "") {
        this.$message.error("请输入详细地址");
        return;
      }
      if (this.mobel == "") {
        this.$message.error("电话不能为空");
        return;
      } else if (this.mobel !== "") {
        var cel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!cel.test(this.mobel)) {
          this.$message.error("请输入有效的电话号码");
          return;
        }
      }
      if (this.remark == "") {
        this.$message.error("请输入处理备注");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      const _this = this;
      if (_this.value110 != null) {
        this.axios
          .get(this.serve+"/admin/agree_return_product", {
            params: {
              username: this.username,
              token: this.token,
              id: this.id,
              remark: this.remark,
              sure_return_money: this.refund,
              express_money: this.express_money,
              address_id: this.address_id
            }
          })
          .then(res => {
          
            if (res.data.status == "success") {
              loading.close();
              _this.$router.push({ path: "/admin/d_returns" });
            }else if(res.data.code == '403'){
              _this.$message.error(res.data.msg); 
              loading.close();
            } else {
              _this.open4();
            }
          });
      } else if (_this.value110 == null) {
        this.axios
          .get(this.serve+"/admin/agree_return_product", {
            params: {
              username: this.username,
              token: this.token,
              id: this.id,
              sure_return_money: this.refund,
              remark: this.remark,
              province: this.province_value,
              city: this.city_value,
              area: this.area_value,
              address: this.address,
              link_mobile: this.mobel,
              name: this.name,
              express_money: this.express_money,
              sure_return_money: this.refund
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              loading.close();
              _this.$router.push({ path: "/admin/d_returns" });
            }else if(res.data.code == '403'){
              _this.$message.error(res.data.msg); 
              loading.close();
            } else {
              _this.open4();
            }
          });
      }
    },
    open4() {
      this.$message.error("提交失败");
    },
    consignee() {
      // 三级联动 省
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/province", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          that.province = res.data;
          that.province_value = res.data.id;
        });
    },
    consignee1(name) {
      //二级列表
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios.get(this.serve+"/city?name=" + name).then(res => {
        that.city = res.data;
        that.city_value = res.data.id;
      });
    },
    consignee2(name) {
      //三级列表
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios.get(this.serve+"/area?name=" + name).then(res => {
        that.area = res.data;
        that.area_value = res.data.id;
      });
    },
    handeladr1(name) {
      //点击一级列表
      this.consignee1(name);
    },
    handeladr2(name) {
      //点击二级列表
      this.consignee2(name);
    },
    site(id) {
      this.select(id);

      this.address_id = id;
      //点击收货点下拉框
      var _this = this;
      this.axios
        .get(this.serve+"/admin/return_address_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var json = res.data.data;
          for (var key in json) {
            if (id == json[key].id) {
              _this.name = json[key].name;
              _this.province_value = json[key].province;
              _this.city_value = json[key].city;
              _this.area_value = json[key].area;
              _this.address = json[key].address;
              _this.mobel = json[key].link_mobile;
            }
          }
        });
    },
    select(id) {
      //选择收货点
      var _this = this;
      this.axios
        .get(this.serve+"/admin/return_address_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var json = res.data.data;
          _this.options = [];
          for (var key in json) {
            var site = json[key].city + json[key].area + json[key].address;
            json[key].address1 = site;
          }

          for (var key in json) {
            _this.options.push(json[key]);
          }
        });
    },
    geting(id) {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/return_product_info", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          if(res.data.status == 'success'){
            var json = res.data.data.product;
            that.tableData.push(json);
            var imgNum = json.images.split(";");
            for (var key in imgNum) {
              that.img = imgNum[0];
            }
          var jsons = res.data.data.results;
          that.orderCode = jsons.orderCode;
          that.create_time = jsons.create_date;
          that.link_mobile = jsons.link_mobile;
          that.mobile = jsons.mobile;
          that.link_name = jsons.link_name;
          that.cause = jsons.cause;
          that.return_type = jsons.return_type;
          that.total_money = jsons.return_money;
          that.express_money = jsons.express_money;
          that.code = jsons.code;

          if (jsons.status == "1") {
            jsons.status = "待处理";
            that.status = jsons.status;
          }
          if (jsons.status == "2") {
            jsons.status = "退货中";
            that.status = jsons.status;

            that.show = false;
            that.show1 = true;
            that.show2 = true;

            that.refund = jsons.sure_return_money;
            that.remark = jsons.remark;
            that.express_money = jsons.express_money;
            that.name = res.data.return_address.name;
            that.province_value = res.data.return_address.province;
            that.city_value = res.data.return_address.city;
            that.area_value = res.data.return_address.area;
            that.address = res.data.return_address.address;
            that.mobel = res.data.return_address.link_mobile;
            //  that.
          }
          if (jsons.status == "3") {
            jsons.status = "已拒绝";
            that.status = jsons.status;
            that.show = false;
            that.remark = jsons.remark;
            that.show2 = true;
          }
          if (jsons.status == "4") {
            jsons.status = "已完成";
            that.show2 = true;
            that.status = jsons.status;
            that.show = false;
            that.refund = jsons.sure_return_money;
            that.remark = jsons.remark;
            that.express_money = jsons.express_money;
            that.name = res.data.return_address.name;
            that.province_value = res.data.return_address.province;
            that.city_value = res.data.return_address.city;
            that.area_value = res.data.return_address.area;
            that.address = res.data.return_address.address;
            that.mobel = res.data.return_address.link_mobile;
          }
          if (jsons.images) {
            var imgs = jsons.images.split(";");
          }

          for (var key in imgs) {
            that.imgage.push(imgs[key]);
          }
          }
        });
    }
  }
};
</script>

<style lang="scss">
.topBar {
  margin-bottom: 40px;
  .el-step__icon {
    height: 54px;
    width: 54px;
  }
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}
.table {
  background: #fff;
  .tab_box {
    width: 97%;
    margin: 0 auto;
    margin-bottom: 16px;

    .tab_tr {
      width: 100%;
      height: 100%;
      border: 1px solid rgba(221, 221, 221, 1);
      .tab_th {
        padding: 0;
        margin: 0;
        width: 160px;
        height: 50px;
        background: rgba(245, 250, 249, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        text-align: right;
        padding-right: 40px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .tab_td {
        padding: 0;
        margin: 0;
        border: 1px solid rgba(221, 221, 221, 1);
        padding-left: 20px;
        font-size: 14px;

        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.filtrate {
  width: 1060px;
  margin-left: 420px;
  // background: orange;
  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }

    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .form-title {
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }

    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}

.brand-page {
  background: #f5f5f5;
  color: #333;

  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }

  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>

